import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "@/contexts/AuthContext";
import { CartProvider } from "@/contexts/CartContext";
import Layout from "@/components/Layout";
import ProtectedRoute from "@/components/ProtectedRoute";

import HomePage from "@/pages/HomePage";
import ShopPage from "@/pages/ShopPage";
import ProductDetailPage from "@/pages/ProductDetailPage";
import CartPage from "@/pages/CartPage";
import CheckoutSuccessPage from "@/pages/CheckoutSuccessPage";
import CustomOrderPage from "@/pages/CustomOrderPage";
import AboutPage from "@/pages/AboutPage";
import ContactPage from "@/pages/ContactPage";
import AdminLoginPage from "@/pages/AdminLoginPage";
import AdminDashboardPage from "@/pages/AdminDashboardPage";
import SafetyPage from "@/pages/SafetyPage";
import RefundsPage from "@/pages/RefundsPage";

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <CartProvider>
          <BrowserRouter>
            <Toaster
              position="top-center"
              toastOptions={{
                style: {
                  background: "#fff",
                  color: "#2C211B",
                  border: "1px solid #EAE3D9",
                  borderRadius: "16px",
                },
              }}
            />
            <Routes>
              <Route path="/" element={<Layout><HomePage /></Layout>} />
              <Route path="/shop" element={<Layout><ShopPage /></Layout>} />
              <Route path="/product/:id" element={<Layout><ProductDetailPage /></Layout>} />
              <Route path="/cart" element={<Layout><CartPage /></Layout>} />
              <Route path="/checkout/success" element={<Layout><CheckoutSuccessPage /></Layout>} />
              <Route path="/custom" element={<Layout><CustomOrderPage /></Layout>} />
              <Route path="/personalise" element={<Layout><CustomOrderPage /></Layout>} />
              <Route path="/about" element={<Layout><AboutPage /></Layout>} />
              <Route path="/contact" element={<Layout><ContactPage /></Layout>} />
              <Route path="/safety" element={<Layout><SafetyPage /></Layout>} />
              <Route path="/refunds" element={<Layout><RefundsPage /></Layout>} />
              <Route path="/admin/login" element={<Layout><AdminLoginPage /></Layout>} />
              <Route
                path="/admin"
                element={
                  <ProtectedRoute>
                    <Layout><AdminDashboardPage /></Layout>
                  </ProtectedRoute>
                }
              />
            </Routes>
          </BrowserRouter>
        </CartProvider>
      </AuthProvider>
    </div>
  );
}

export default App;
